import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import NavBar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';
import Header from './components/Header.jsx';
import Home from './pages/Home.jsx';
import Club from './pages/Club.jsx';
import Event from './pages/Events.jsx';
import Member from './pages/Member.jsx';
import Datenschutz from './pages/Datenschutz.jsx';
import Impressum from './pages/Impressum.jsx';
import Erste from "./pages/Erste.jsx";
import Zweite from "./pages/Zweite.jsx";
import Mixed from "./pages/Mixed.jsx";
import Frauen from "./pages/Frauen.jsx";
import ScrollToTop from "./components/ScrollToTop.js";
import Kontakt from "./pages/Kontakt.jsx";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Sponsoring from "./pages/Sponsoring.jsx";
import Tournaments from "./pages/tournaments.jsx";
import axios from "axios";
import PollLogin from "./pages/PollLogin.jsx";
import PollPage from "./pages/Poll.jsx";
import Grillfeier from "./pages/Grillfeier.jsx"
const BASE_URL = 'https://rakete-freiburg.de';
export const IMAGE_URL = `${BASE_URL}/api/images`;

function App() {
  axios.defaults.baseURL = `${BASE_URL}/api/`;
  axios.defaults.withCredentials = true;



  useEffect(() => {
    const fetchVisit = async () => {
      try {
        await axios.get('/visit');
      } catch (error) {
        console.error('Server nicht erreichbar');
      }
    };
    fetchVisit();
  }, []);

  return (
    <div className="App max-size mx-auto shadow">
      <ScrollToTop />
      <ToastContainer />
      <NavBar />
      <Header />
      <Routes>
        <Route path="*" element={<Home />} />
        <Route index element={<Home />} />
        <Route path="club" element={<Club />} />
        <Route path="events" element={<Event />} />
        <Route path="erste" element={<Erste />} />
        <Route path="zweite" element={<Zweite />} />
        <Route path="mixed" element={<Mixed />} />
        <Route path="frauen" element={<Frauen />} />
        <Route path="member" element={<Member />} />
        <Route path="datenschutz" element={<Datenschutz />} />
        <Route path="impressum" element={<Impressum />} />
        <Route path="kontakt" element={<Kontakt />} />
        <Route path="sponsor" element={<Sponsoring />} />
        <Route path="poll/:pollId" element={<PollPage />} />
        <Route path="tournament/:id" element={<Tournaments />} />
        <Route path="raketencup" element={<Tournaments tournamentKey="67308708eada848f842dedfa" />} />
        <Route path="mittsommercup" element={<Tournaments tournamentKey="67e96086e6202e461a166bb6" />} />
        <Route path="grillfeier" element={<Grillfeier props={undefined} />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
